import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/FinancialReport`;
const reportUrl = `${process.env.REACT_APP_API_ENDPOINT}/Reports/FinancialReport`;

class FinancialReportService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getFinancialReport(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id);
    } catch (e) {
      throw e;
    }
  }

  public getFinancialReportDashboard(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "dashboard" });
    } catch (e) {
      throw e;
    }
  }

  public getFinancialReportList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "list" });
    } catch (e) {
      throw e;
    }
  }

  public updateFinancialReport(
    body: any,
    id: number
  ): Promise<IApiResponse | void> {
    try {
      return super.update(body, id);
    } catch (e) {
      throw e;
    }
  }

  public removeFinancialReport(id: number): Promise<IApiResponse | void> {
    try {
      return super.delete(id);
    } catch (e) {
      throw e;
    }
  }

  public getFinancialReportSummary(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "debtsummary" });
    } catch (e) {
      throw e;
    }
  }

  public printFinancialReport(id: number): Promise<IApiResponse | void> {
    this.setUrl(reportUrl);
    try {
      return super.getFileById(id);
    } catch (e) {
      throw e;
    }
  }
}
const financialReportAPI = new FinancialReportService(url);
export default financialReportAPI;
